"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.369 4.75h17.263v2.074H3.369zm0 4.138h12.436v2.074H3.369zm0 4.149h7.948v2.074H3.369zm0 4.139h4.149v2.074H3.369z"
}), 'SortDesc');
